import request from '@/utils/http';
import { SRM, SRM_FILE } from '../constant/constant.js';

// 月度绩效列表
export const supplierLegalPersonPerformanceList = data => {
    return request({
        url: `${SRM}/supplierLegalPersonPerformanceList`,
        method: 'post',
        data,
    })
}
// 月度绩效列表导出
export const exportLegalPersonPerformance = data => {
    return request({
        url: `${SRM_FILE}/exportLegalPersonPerformance`,
        method: 'post',
        data,
    })
}

// 变更绩效状态
export const updateSupplierLegalPersonPerformanceStatus = data => {
    return request({
        url: `${SRM}/updateSupplierLegalPersonPerformanceStatus`,
        method: 'post',
        data,
    })
}
// 保存绩效附件
export const addSupplierLegalPersonPerformanceFile = data => {
    return request({
        url: `${SRM}/addSupplierLegalPersonPerformanceFile`,
        method: 'post',
        data,
    })
}
// 审批人配置列表
export const querySupplierLegalPersonPerformanceApproveList = data => {
    return request({
        url: `${SRM}/supplierLegalPersonPerformanceApprove/queryList`,
        method: 'post',
        data,
    })
}
// 新增审批人
export const querySupplierLegalPersonPerformanceApproveListAdd = data => {
    return request({
        url: `${SRM}/supplierLegalPersonPerformanceApprove/add`,
        method: 'post',
        data,
    })
}

// 修改审批人
export const querySupplierLegalPersonPerformanceApproveListUpdate = data => {
    return request({
        url: `${SRM}/supplierLegalPersonPerformanceApprove/update`,
        method: 'post',
        data,
    })
}
// 删除审批人
export const querySupplierLegalPersonPerformanceApproveListDelete = params => {
    return request({
        url: `${SRM}/supplierLegalPersonPerformanceApprove/delete`,
        method: 'get',
        params,
    })
}
// 获取绩效附件信息
export const getSupplierLegalPersonPerformanceFile = params => {
    return request({
        url: `${SRM}/getSupplierLegalPersonPerformanceFile`,
        method: 'get',
        params,
    })
}
// 获取详情
export const selectSupplierPerformanceConfigurationAdjustDetail = params => {
    return request({
        url: `${SRM}/selectSupplierPerformanceConfigurationAdjustDetail`,
        method: 'get',
        params,
    })
}
// 删除附件
export const deletePersonFile = params => {
    return request({
        url: `${SRM}/deletePersonFile`,
        method: 'get',
        params,
    })
}
// 操作记录列表
export const selectOperativeRecord = params => {
    return request({
        url: `${SRM}/selectOperativeRecord`,
        method: 'get',
        params,
    })
}
// 重新计算排名
export const recalculateRanking = params => {
    return request({
        url: `${SRM}/recalculateRanking`,
        method: 'get',
        params,
    })
}
// 绩效计算配置详情
export const selectLegalPersonPerformanceConfiguration = params => {
    return request({
        url: `${SRM}/selectLegalPersonPerformanceConfiguration`,
        method: 'get',
        params,
    })
}
// 修改绩效计算配置
export const addLegalPersonPerformanceConfiguration = data => {
    return request({
        url: `${SRM}/addLegalPersonPerformanceConfiguration`,
        method: 'post',
        data,
    })
}
// 绩效计算配置记录
export const selectSupplierLegalPersonPerformanceConfigurationPage = data => {
    return request({
        url: `${SRM}/selectSupplierLegalPersonPerformanceConfigurationPage`,
        method: 'post',
        data,
    })
}
// 运输-输入指标完成获取对应得分
export const getScoreByValue = data => {
    return request({
        url: `${SRM}/getScoreByValue`,
        method: 'get',
        params: data
    });
};

// 法人绩效-提交绩效调整
export const submitAdjust = data => {
    return request({
        url: `${SRM}/submitPerformanceConfigurationAdjust`,
        method: 'post',
        data
    });
};

// 法人绩效-无需整改原因
export const selectNeedNotRectificationReason = params => {
    return request({
        url: `${SRM}/selectNeedNotRectificationReason`,
        method: 'get',
        params
    });
};
